import React from 'react';
import queryString from 'query-string';
import { Form, Progress } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './image/logo.png';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'cdi';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Usuário não existe na base de dados ou foi desconetado.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;
    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <Form onSubmit={event => this.onSubmit(event)} className="cdi-container">
          <div className='cdi-logo-container' ref={this.ref}>
            <img className='cdi-logo' src={logo} alt='cdi' />
          </div>
          <label className='label-cdi'>CPF/CNPJ</label>
          <input
            className='form-control input-cdi'
            disabled={this.state.onLogin}
            ref={(ref) => {
              this.usernameInput = ref;
            }
            }
            required={true}
            tabIndex={1}
            type="text"
            autoCorrect="off"
            autoCapitalize="none"
            name="username"
          />
          <label className='label-cdi'>Senha</label>
          <input
            className='form-control input-cdi'
            required={true}
            disabled={this.state.onLogin}
            ref={(ref) => {
              this.passwordInput = ref;
            }
            }
            tabIndex={1}
            type="password"
            autoCorrect="off"
            autoCapitalize="none"
            name="password"
          />
          {!this.state.onLogin ?
            <button
              className='cdi-button btn btn-primary'
              block={!this.parameters.failureRedirect}
              tabIndex={1}
              type="submit"
              name="submit"
              disabled={!this.props.turnstileSuccess}
            >
              {translate('ButtonEnter')}
            </button> :
            <Progress animated color="primary" value={100} className='cdi-progress' />}
          <div className='cdi-error-container'>
            <strong className='cdi-error-msg'>{this.state.error.message} </strong>
          </div>
          <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
        </Form>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
